/* eslint-disable @typescript-eslint/naming-convention */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { DispatchPlanHistory } from 'views/FleetPlanner/DispatchPlanHistory/DispatchPlanHistory';
import type dayjs from 'dayjs';
import { type Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

export const PlanHistoryModal = ({
  open,
  onClose,
  date,
  handleDateChange,
  selectedDateRange,
}: {
  open: boolean;
  onClose: () => void;
  selectedDateRange: string;
  date: dayjs.Dayjs | null;
  handleDateChange: (
    range: string,
    date: Dayjs | null,
    shouldFetchActivePlan: boolean,
    isButtonClick?: boolean
  ) => Promise<void>;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xl'}
      PaperProps={{
        sx: {
          backgroundColor: 'customBackground.modal',
          borderRadius: 3,
          width: '95vw',
        },
        elevation: 1,
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // darker overlay
            backdropFilter: 'blur(2px)', // adds a soft blur behind
          },
        },
      }}
    >
      <DialogTitle
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {t('approved_plan_history')}
        <IconButton onClick={onClose} style={{ color: '#94a3b8' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />

      <DialogContent
        sx={{
          display: 'flex',
          padding: 0,
          height: '98vh',
        }}
      >
        <DispatchPlanHistory
          date={date}
          onClose={onClose}
          handleDateChange={handleDateChange}
          selectedDateRange={selectedDateRange}
        />
      </DialogContent>
    </Dialog>
  );
};
